import React from 'react';

const About = () => (
    <div style={{ padding: '2rem' }}>
        <h2>About This Site</h2>
        <p>
            This is an example Oklahoma Citizen web site demonstrating Azure AD B2C authentication and redirect handling.
        </p>
        <h3>Using Azure AD B2C</h3>
        <p>
            Azure Active Directory B2C is used to manage user authentication for this site. It allows users to sign in securely using their Microsoft or other supported accounts. The integration is handled via the Azure AD B2C service, which manages user flows and policies.
        </p>
        <h3>Implementing the State Parameter</h3>
        <p>
            The <code>state</code> parameter is used during authentication to preserve application state or the user's intended destination. When a user initiates login, the app includes a <code>state</code> value in the authentication request. After authentication, Azure AD B2C returns this value, allowing the app to redirect the user back to the correct page or restore context.
        </p>
    </div>
);

export default About;
